/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dw-f-pop-tag-select[_ngcontent-%COMP%]{position:absolute;width:72%;height:40px;bottom:5px;overflow:auto}.dw-f-pop-tag-select[_ngcontent-%COMP%]   dw-tag.dw-f-tag-s[_ngcontent-%COMP%]{margin-bottom:3px;display:inline-block}\n/*# sourceMappingURL=select-modal.component.css.map*/"];
export { styles as styles };
